import palette from '../palette';
const createShadowGradient = (...px) => {
  return `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px`;
};
const gradients = [[], [0, 3, 12, -6], [0, 5, 20, -6], [0, 4, 32, -2], [0, 4, 32, -2], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []];
export const createShadows = (baseColor = palette.INK_20) => {
  return gradients.map(gradient => {
    if (!gradient.length) return 'none';
    return `${createShadowGradient(...gradient)} ${baseColor}`;
  });
};
const shadows = createShadows(palette.INK_20);
export default shadows;